import { render, staticRenderFns } from "./DueDiligenceForm.vue?vue&type=template&id=4337774b&"
import script from "./DueDiligenceForm.vue?vue&type=script&lang=js&"
export * from "./DueDiligenceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4337774b')) {
      api.createRecord('4337774b', component.options)
    } else {
      api.reload('4337774b', component.options)
    }
    module.hot.accept("./DueDiligenceForm.vue?vue&type=template&id=4337774b&", function () {
      api.rerender('4337774b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/forms/due-diligence/DueDiligenceForm.vue"
export default component.exports